import fetch from '../utils/fetch';
// import fetch from '../utils/fetch'
// import { baseUrl } from '../utils/env';
let baseUrl = "https://console.bonuscloud.io";

export const ajaxIPInfo = () => {
  return fetch(baseUrl + '/api/user/getIPInfo');
};